import { Link } from "react-router-dom";
import { useState } from "react";

const ServiceCard = ({ title, description, image, link, index }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="group bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 h-full flex flex-col">
      {/* Image */}
      <div className="h-64 overflow-hidden bg-gray-100 relative flex-shrink-0">
        <img
          src={image}
          alt={`${title} - Vasavi Structures Hyderabad`}
          className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          loading={index < 2 ? "eager" : "lazy"}
          fetchPriority={index < 2 ? "high" : "auto"}
          onLoad={() => setImageLoaded(true)}
        />
        {!imageLoaded && (
          <div className="absolute inset-0 bg-gray-200 animate-pulse" />
        )}
      </div>

      {/* Content - grows to push "Learn More" to bottom */}
      <div className="p-8 flex flex-col flex-grow">
        <h3 className="font-montserrat text-2xl font-bold text-gray-900 mb-4">
          {title}
        </h3>
        <p className="text-gray-600 leading-relaxed flex-grow">
          {description}
        </p>

        {/* THIS IS THE MAGIC — fixed position at bottom */}
        <div className="mt-8 pt-4 border-t border-gray-100">
          <Link
            to={link}
            className="inline-flex items-center font-montserrat font-bold text-primary group"
            aria-label={`Learn more about ${title}`}
          >
            Learn More
            <svg
              className="w-5 h-5 ml-2 transition-transform duration-300 group-hover:translate-x-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;